<div
  class="c-randomPrize"
  theming
  themingGroup="randomprize"
  themingAsset="minigame-background"
  [themingOverride]="event()?.assets">
  <span class="text title">{{ 'home.live-ops.randomprize.modal-minigame.title' | translate }}</span>

  <div class="w-100 h-100 d-flex justify-content-center align-items-center">
    <div
      class="c-randomPrize__awards"
      [ngClass]="multiplierList().length <= 4 ? 'c-randomPrize__awards--small' : ''">
      @if (grid) {
        <div class="grid-container">
          @for (cell of grid.cells; track cell; let i = $index) {
            <div
              [class]="'c-randomPrize__award'"
              data-testid="random-prize-award"
              [ngStyle]="{
                position: 'absolute',
                width: getStrValue(cell.metrics.width),
                height: getStrValue(cell.metrics.height),
                top: getStrValue(cell.metrics.positionY),
                left: getStrValue(cell.metrics.positionX),
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center'
              }">
              <div
                class="cell-content"
                [ngClass]="{ 'cursor-pointer': activateCursor() }"
                (click)="openSelectedCookie(cell)">
                <div
                  class="cell-img"
                  [ngClass]="{
                    'swing-animation': activateCursor(),
                    'zoomIn-animation': !togglePercentAnimation
                  }"
                  theming
                  themingGroup="randomprize"
                  [themingAsset]="manageIconsFn(cell, multiplierList()[i])"
                  [themingOverride]="event()?.assets"></div>

                <span
                  class="cell-percent"
                  [ngClass]="{
                    'zoomInOut-animation': togglePercentAnimation(),
                    'zoomIn-animation': !togglePercentAnimation(),
                    'cell-percent--selected': selectedIndex() === i,
                    'cell-percent--unselected': selectedIndex() !== null && selectedIndex() !== i
                  }">
                  {{
                    (multiplierList()[i] / 100) * randomPrizeMinigameModalData.data.properties.purchase
                      | beautifyNumber: ('common.culture' | translate)
                  }}
                </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
